import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { resetCurrentNodeLevelStateAndAbove } from "../utils/resetCurrentNodeLevelStateAndAbove";
import {
  StepPage,
  routeToStepPage,
  selfServePageToStepAndRoute,
  selfServePageToStepAndRouteWithoutOrderSelection,
  stepPageToNodeLevelAboveThatNeedsToBeCleaned,
} from "../view/step";

import { useNavigationStore } from "./NavigationContext";
import { useSelfServeContextStore } from "./SelfServeContext";

export const useNavigationInitializationEffect = () => {
  const { pathname } = useLocation();
  const [{ currentPage }, setNavigationStore] = useNavigationStore([
    "currentPage",
  ]);
  const [{ brandOrders }, setSelfServeContextStore] = useSelfServeContextStore([
    "brandOrders",
  ]);

  useEffect(() => {
    const stepPage = routeToStepPage[pathname] as StepPage;
    const currentPageChanged = currentPage !== stepPage;
    if (currentPageChanged) {
      if (brandOrders && brandOrders.length > 0) {
        setNavigationStore({
          currentStep: selfServePageToStepAndRoute[stepPage].step,
          currentPage: stepPage,
        });
        resetCurrentNodeLevelStateAndAbove({
          level: stepPageToNodeLevelAboveThatNeedsToBeCleaned[stepPage],
          setSelfServeContextStore,
        });
      } else {
        setNavigationStore({
          currentStep:
            selfServePageToStepAndRouteWithoutOrderSelection[stepPage].step,
          currentPage: stepPage,
        });
        resetCurrentNodeLevelStateAndAbove({
          level: stepPageToNodeLevelAboveThatNeedsToBeCleaned[stepPage],
          setSelfServeContextStore,
        });
      }
    }
  }, [
    brandOrders,
    currentPage,
    pathname,
    setNavigationStore,
    setSelfServeContextStore,
  ]);
};
